/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * Copyright (c) 2013 MOCA Systems, Inc.  All rights reserved.
 *
 * src/main/resources/com/mocasystems/mb4/ui/ng/ticketspace-directives.js
 *
 * Angular directives for ticketspace-app.js.
 */

'use strict';

import * as angular from 'angular';
import * as moment from 'moment';
import * as Pikaday from 'pikaday';

import { bind, clipString, throttle } from 'utils/basic-utils';

import { analyticsEventsService } from 'src/app/plain-javascript/services/analytics/AnalyticsEventsService';

import Point from '@appLegacy/lib/math/Point';

import AnimationQueue from '@appLegacy/lib/ui/AnimationQueue';
import Redom from '@appLegacy/lib/ui/Redom';
import { Redom2 } from '@appLegacy/lib/ui/Redom';
import {
	CONSTRAINT_LINKED_TO_PROCORE,
	CONSTRAINT_ON_LOCKED_PLAN,
	CONSTRAINT_CANNOT_COMPLETE_ON_PULL_SIDE,
} from '@touchplan/strings';
import { PLAN_CONSTANTS } from '@touchplan/common';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import { ProcoreService } from 'src/app/services/procore.service';
import { last } from 'rxjs/operators';

declare const window: any;
declare const fancyNotification: any;
declare const Intercom: any;

declare const MCScope: any; //bad kevin, bad...

angular
	.module('ticketspaceApp.directives')

	.directive('dow', function () {
		return {
			scope: true,
			require: 'ngModel',
			link: function (scope: any, element, attrs, modelCtrl: any) {
				//logger.log('dow', scope);
				scope.week = [
					{ day: 'Monday', checked: false },
					{ day: 'Tuesday', checked: false },
					{ day: 'Wednesday', checked: false },
					{ day: 'Thursday', checked: false },
					{ day: 'Friday', checked: false },
					{ day: 'Saturday', checked: false },
					{ day: 'Sunday', checked: false },
				];

				var loaded = false;

				modelCtrl.$render = function () {
					var v = modelCtrl.$viewValue;
					scope.week.forEach(function (day: any, idx: any) {
						if (v) {
							day.checked = !!v[idx];
						} else {
							day.checked = false;
						}
					});
				};

				var unwatch = scope.$watch(
					'week',
					function () {
						scope.$applyAsync(function () {
							if (loaded) {
								modelCtrl.$setViewValue(
									scope.week.map(function (day: any) {
										return day.checked ? 1 : 0;
									})
								);
							}
							if (modelCtrl.$viewValue) {
								loaded = true;
							}
						});
					},
					true
				);

				scope.$on('$destroy', function () {
					unwatch();
				});
			},
			template: require('html-loader?root=src/!tpl/dow-selector.html'),
		};
	})

	.directive('scrollOnClickParent', [
		function () {
			return {
				controller: [
					'$element',
					function ($element) {
						this.parentElement = $element;
					},
				],
			};
		},
	])

	.directive('scrollOnClick', [
		'$timeout',
		'$parse',
		function ($timeout, $parse) {
			function link(scope: any, element: any, attrs: any, parentCtrl: any) {
				var parentElement = parentCtrl ? parentCtrl.parentElement : element.parent();

				element.click(function (event: any) {
					//abort
					var parsed = $parse(attrs.scrollOnClick);

					if (
						event.target.nodeName === 'BUTTON' ||
						event.target.nodeName === 'INPUT' ||
						event.target.nodeName === 'TEXTAREA' ||
						event.target.nodeName === 'SELECT' ||
						(!parsed(scope) && parsed(scope) !== undefined)
					) {
						//undefined is fine
						return;
					}
					//	logger.log('top', event.target.nodeName, element, element.position());

					$timeout(function () {
						var top = parentElement.scrollTop() + element.position().top;
						//logger.log('top2', element.parent().scrollTop(), element.position().top, top)
						if (!isNaN(top)) {
							parentElement.animate({ scrollTop: top + 'px' });
						}
					});
				});
			}
			return {
				require: '?^^scrollOnClickParent',
				link: link,
			};
		},
	])

	.directive('viewBlocker', [
		'$timeout',
		function ($timeout) {
			function compile(element: any, attrs: any) {
				window.blocked = true;
				return link;
			}
			function link(scope: any, element: any, attrs: any) {
				function destroy(val: any) {
					if (val) {
						unwatch();
						$timeout(function () {
							element.remove();
						}, 50);
						//element.remove()
						window.blocked = false;
					}
				}

				var unwatch = scope.$watch(attrs.viewBlocker, destroy);
			}
			var template =
				'<div class="blocker-loading-wrapper"><mat-spinner [diameter]="100"></mat-spinner></div>';
			return { compile: compile, template: template };
		},
	])

	.directive('namifyZoom', [
		function () {
			function link(scope: any, element: any, attrs: any) {
				var unwatch = scope.$watch('hud', function (val: any) {
					if (val) {
						unwatch();
					} else {
						return;
					}
					var selection: any;
					function classIt(c: any) {
						if (selection === c) {
							return;
						}

						if (selection) {
							element.removeClass(selection);
						}
						element.addClass(c);
						selection = c;
					}
					scope.orderedExecution.add('namifyZoom', function () {
						var z = scope.hud.z;
						if (z < 0.2 && window.isiPad) element.addClass('disable-animation');
						else element.removeClass('disable-animation');
						if (z < 0.157) {
							classIt('dz-05');
						} else if (z < 0.2375) {
							classIt('dz-1');
						} else if (z < 0.35) {
							classIt('dz-2');
						} else if (z < 0.6) {
							classIt('dz-3');
						} else if (z < 0.99) {
							classIt('dz-4');
						} else {
							classIt('dz-5');
						}
					});
				});
			}

			//Hold the responsive font after the lines appear. Cover more area than middle one
			//Large ticket interval larger
			//Large font size tickets on 4+ day tickets gives incentive that it's more important.

			return { link: link };
		},
	])
	//updates the postion of the today line by latching onto the hud.observers array
	//directly updates the styling with javascript dom api
	.directive('displayLine', [
		'shiftApi',
		function (shiftApi) {
			const logger = LoggerServiceFactory.create('displayLine');
			function wrap(innerHtml: any, override: any) {
				//logger.log('override', override);
				if (override) {
					return innerHtml;
				} else {
					return $('<div class="milestone-line">').append(
						$('<div class="milestone-name">').append(innerHtml)
					);
				}
			}

			function link(scope: any, elem: any, attrs: any, __, transcludeFn: any) {
				var shiftOffset = 0;
				var isHidden = true;

				transcludeFn(function (elemClone: any, newScope: any) {
					elem.append(wrap(elemClone, attrs.overrideContents));
					scope.$on('$destroy', function () {
						elemClone.remove();
						newScope.$destroy();
					});
				});

				var lineObj: any;
				//logger.log(attrs);

				var offset = 0;
				if (attrs.offset && parseInt(attrs.offset)) {
					offset = parseInt(attrs.offset);
					elem.css({ width: Math.abs(offset) + 16 + 'px' });
				}

				var unbindLine = scope.$watch(attrs.displayLine, function (value: any) {
					if (value) {
						unbindLine();
						lineObj = value;
						checkVisibility();
						value.$watch(checkVisibility);
					}
				});

				function update() {
					if (!scope.hud) {
						return;
					} //async call of destroyed code
					if (lineObj && lineObj.$value !== null) {
						var xx = (lineObj.$value + shiftOffset) * scope.hud.z + scope.hud.x + offset / 2; // column position
						elem[0].style.left = xx + 'px';
					} else {
						//if(attrs.id === "milestone-line"){
						if (attrs.elementType === 'milestone') {
							//logger.log('do something');
							//logger.log('test',scope.pullColumns[0].finishX * scope.hud.z + scope.hud.x);
							if (
								scope.pullColumns &&
								scope.pullColumns.length &&
								scope.pullColumns[0].finishX * scope.hud.z + scope.hud.x > window.innerWidth
							) {
								if (!isHidden) {
									elem.addClass('hide');
									isHidden = true;
								}
							} else {
								if (isHidden) {
									elem.removeClass('hide');
									isHidden = false;
								}
							}
						}
					}
				}

				function shiftLine(x: any, activeLineX: any, side: any) {
					if (!lineObj || lineObj.$value === null) {
						return;
					}
					if (attrs.id === 'today-line' || attrs.elementType === 'milestone') {
						if (side === 'pull' && lineObj.$value > activeLineX) {
							shiftOffset += x;
							if (lineObj.$value + shiftOffset < activeLineX) {
								elem.addClass('hide');
							} else {
								elem.removeClass('hide');
							}
						} else if (side === 'active' && lineObj.$value <= activeLineX) {
							shiftOffset += x;
							if (lineObj.$value + shiftOffset > activeLineX) {
								elem.addClass('hide');
							} else {
								elem.removeClass('hide');
							}
						}
					}
					//if(attrs.id === "today-line" && side === "pull"){return;}

					update();
				}
				var preShiftOffset;
				if (attrs.allowShift) {
					shiftApi.subscribe(shiftLine);
					shiftApi.on('shiftStart', function () {
						//preShiftOffset = shiftOffset;
					});
					shiftApi.on('shiftEnd', function () {
						//shiftOffset = preShiftOffset;
						elem.removeClass('hide');
						update();
					});
					shiftApi.on('update', function () {
						logger.log('update the shift');
						checkVisibility();
					});
					shiftApi.on('shiftCleanup', function (x: any, activeLineX: any, side: any) {
						shiftLine(x, activeLineX, side);
						//logger.log('cleanup', x, side);
						elem.removeClass('hide');
					});
				}

				function checkVisibility() {
					if (!lineObj || lineObj.$value === null) {
						if (attrs.elementType === 'milestone') {
							elem.addClass('dateless-milestone');
							elem.css({ left: '' });
						} else if (attrs.elementType === 'activeLine' || attrs.elementType === 'activeLineNub') {
							elem.addClass('dateless-active-line');
							elem.css({ left: '' });
						} else {
							elem.addClass('hide');
						}
					} else {
						if (attrs.elementType === 'milestone') {
							elem.removeClass('dateless-milestone');
						} else if (attrs.elementType === 'activeLine' || attrs.elementType === 'activeLineNub') {
							elem.removeClass('dateless-active-line');
						} else {
							elem.removeClass('hide');
						}
					}
					shiftOffset = 0;
					scope.hud.update();
				}

				scope.$on('$destroy', function () {
					unbindLine();
					unbind();
				});

				var unbind = scope.$watch('hud', function () {
					unbind();
					scope.orderedExecution.add(
						'drawDisplayLine',
						bind(this, function () {
							AnimationQueue(update);
						})
					);
				});
			}

			return {
				restrict: 'EA',
				compile: function (element, attrs) {
					element.addClass('display-line');
					return link;
				},

				transclude: true,
				/*
		template: '\
					<div class="milestone-line">\
						<div class="milestone-name" ng-transclude>\
						</div>\
					</div>\
		'
		*/
			};
		},
	])

	//updates the date of the today line
	.directive('todayDate', [
		function () {
			return {
				restrict: 'A',
				link: function (scope: any, elem, attrs) {
					const logger = LoggerServiceFactory.create('todayDate');
					function updateText(text: any) {
						elem.text('Today: ' + moment(text).format('MMM D YYYY'));
					}

					var unbind = scope.$watch(attrs.todayDate, function (value: any) {
						if (value) {
							unbind();
							if (!value.$watch) {
								logger.error('todayDate value is not an angularfire reference');
								return;
							}
							updateText(value.$value);
							value.$watch(function () {
								updateText(value.$value);
							});
						}
					});
				},
			};
		},
	])

	.directive('shadeNonWorkDays', [
		'activeColumnService',
		function (activeColumnService) {
			var redomColumn = new Redom('<div class="background-area-work"></div>');
			var dates = {
				Mon: 0,
				Tue: 1,
				Wed: 2,
				Thu: 3,
				Fri: 4,
				Sat: 5,
				Sun: 6,
			};
			return {
				restrict: 'EA',
				scope: {
					workDays: '=',
					displayWorkDays: '=',
				},
				link: function (scope: any, element, attrs) {
					// logger.log('shade created');
					var store = {
						cols: null,
						min: null,
						max: null,
					};
					var isDestroyed = false;

					var drawColumn = function (columnDoms, col) {
						var inner = columnDoms.pop()[0];
						inner.style.left = col.startX + 'px';
						inner.style.width = activeColumnService.width() + 'px';
						element[0].appendChild(inner);
					};

					function update() {
						if (isDestroyed) {
							return;
						} //handle some async timing crap
						element.empty();
						if (!activeColumnService.$loadedSync()) {
							return;
						}
						var zoomStage = activeColumnService.getZoomStage();
						if (zoomStage > 1) {
							return;
						} //abort when columns start gettings removed

						if (store.cols) {
							var columnDoms = redomColumn.get(store.max - store.min);
							for (var i = store.min; i < store.max; i++) {
								var col = store.cols[i];
								// If project
								if (scope.displayWorkDays === 'project') {
									if (!scope.workDays.isWork(col.activeDay)) {
										drawColumn(columnDoms, col);
									}
								} else if (scope.displayWorkDays && scope.displayWorkDays.data.workShiftsByDow) {
									if (
										scope.displayWorkDays.data.workShiftsByDow[dates[col.minDate]] === 0 ||
										(scope.workDays.projectExceptionDays &&
											scope.workDays.projectExceptionDays.$getRecord(col.activeDay))
									) {
										drawColumn(columnDoms, col);
									}
								}
								/*
						if (scope.displayWorkDays !== 'project' && scope.displayWorkDays.data.workShiftsByDow && scope.displayWorkDays.data.workShiftsByDow[dates[col.minDate]] === 0) {
							drawColumn(columnDoms, col);
						} else if (!scope.displayWorkDays === 'project' && !scope.workDays.isWork(col.activeDay)){
							drawColumn(columnDoms, col);
						}
						*/
							}
						}
					}

					var unsub = activeColumnService.subscribe(function (cols, min, max) {
						// logger.log('shade subscription', arguments);
						store.cols = cols;
						store.min = min;
						store.max = max;
						update();
					});

					var unwatch = scope.workDays.$watch(function () {
						update();
					});

					var displayUnwatch = scope.$watch(
						'displayWorkDays',
						function () {
							update();
						},
						true
					);

					scope.$on('$destroy', function () {
						// logger.log('shade destroyed');
						isDestroyed = true;
						unwatch();
						displayUnwatch();
						activeColumnService.unsubscribe(unsub);
						// scope.workDays.$destroy();
					});
				},
			};
		},
	])

	.directive('datePicker', [
		function () {
			var require = '?ngModel';
			function link(scope, element, attrs, ngModel) {
				//element.attr('type', 'text');

				//angular 1.3 apparently decided on the stupid decision to require
				//a date literal for input[date], which makes working with dates from
				//firebase a non-starter, in theory this should disable date validation
				if (ngModel) {
					ngModel.$formatters = [];
					ngModel.$parsers = [];
				}

				if (element[0].type == 'text') {
					element.attr('placeholder', 'yyyy-mm-dd');
					var Pk: any = Pikaday;
					var picker = new Pk({
						field: element[0],
						defaultDate: moment().format('YYYY-MM-DD'),
						minDate: moment().subtract(50, 'years').toDate(),
						maxDate: moment().add(50, 'years').toDate(),
						parse: function (dateString, format) {
							var isSane = dateString && /[12]\d\d\d-\d\d-\d\d/.test(dateString);
							if (isSane) {
								return moment(dateString).toDate();
							} else {
								return undefined;
							}
						},
					});
					if (ngModel) {
						ngModel.$formatters.push(function (value) {
							if (value) {
								picker.gotoDate(new Date(value));
							}
							return value;
						});
					}
				}
			}
			return {
				require: require,
				link: link,
				priority: 10,
			};
		},
	])

	.directive('clearableInput', function () {
		return {
			restrict: 'A',
			//scope: {model: '=ngModel'},
			require: '?ngModel',

			link: function (scope: any, element, attrs, ngModel: any) {
				var newElement = angular
					.element('<i class="material-icons notranslate input-x">close</i>')
					.insertAfter(element);
				element.addClass('clearable-input');

				if (element.prop('tagName') == 'TEXTAREA') {
					element.css({ 'vertical-align': 'top' });
				}

				newElement.css({ display: 'none' });

				element.on('focus', function () {
					newElement.css({ display: 'inline-block' });
				});
				element.on('blur', function () {
					newElement.css({ display: 'none' });
				});

				newElement.on('mousedown', function (e) {
					if (e.originalEvent?.button === 0) {
						if (ngModel) {
							ngModel.$setViewValue('');
						}
						element.val('');
					}
					return false;
				});
			},
		};
	})

	.directive('constraintSidePanel', [
		'$timeout',
		function ($timeout) {
			return {
				scope: true,
				template: require('html-loader?root=src/!tpl/constraints/constraint-panel.html'),
				controllerAs: 'ctrl',
				bindToController: {
					constraints: '=',
				},
				controller: [
					'$scope',
					'$attrs',
					'procoreService',
					function ($scope, $attrs, procoreService: ProcoreService) {
						this.$onInit = function () {
							this.constraints.toggleShowCompleted(this.sortByCompleted);
						};

						this.sortOptions = [
							{ label: 'Planned Date', value: 'plannedFinish' },
							{ label: 'Need By Date', value: 'dateRequested' },
							{ label: 'Created Date', value: 'createdAt' },
							{ label: 'Priority', value: 'priority' },
							{ label: 'Plan Name', value: 'plan' },
							{ label: 'Responsible Individual', value: 'responsibleIndividual' },
						];
						var self = this;
						//setup external api, now THERE CAN ONLY BE ONE
						$scope.$watch($attrs.api, function (val) {
							if (val) {
								val.tryOpenDetails = function tryOpenDetails(constraintId) {
									var constraint = self.constraints.$getRecord(constraintId);
									if (constraint) {
										self.toggleConstraintEditor(constraint, true);
									}
								};
							}
						});

						//should now be able to access the passed in constraint list as:
						// scope.ctrl.constraints from here
						// this.constraints in the controller
						// and ctrl.constraints in the template

						// Track which constraint note is opened by using the constraint $id
						this.constraintNoteID = null;
						this.sortBy = 'plannedFinish';
						this.sortByCompleted = false;

						this.showForCurrentPlanOnly = false;
						this.showOnlyLate = false;
						this.priorityList = null;
						this.constraintData = {};

						$scope.legacyImages = {
							procoreLogoSmall: 'assets/images/procore-logo-small.png',
						};

						this.toggleConstraintEditor = function (constraint, forceOpen) {
							if (forceOpen) {
								this.constraintNoteID = null;
							} //literally the laziest way to do this
							if ($scope.planHasRestrictedAccess(constraint._debugIdxData['planId'])) {
								Logging.warning(CONSTRAINT_ON_LOCKED_PLAN($scope.planAccessCheck.accessLevelSync));
							}
							// Remove highlight if the ticket exists in plan.
							// if(this.constraintNoteID){
							// 	var split = this.constraintNoteID.split(',');
							// 	if (split[0] === $scope.plan.$id) { $scope.tickets.selection.remove(split[1]);}
							// }
							// This closes the note editor if the IDs match.
							if (constraint.$id === this.constraintNoteID) {
								this.constraintNoteID = null;
								return;
							}
							this.constraintNoteID = constraint.$id;
							this.savedData = this.constraints.getEditData(this.constraintNoteID); //calling the getter is essential, it does some internal massaging
							this.priorityList = $scope.priorities.$getRecord(constraint.data.priorityId);
							this.locationList = $scope.locations.$getRecord(constraint.data.locationId);
							this.constraintData.constraint = this.constraints.$getRecord(this.constraintNoteID);
							// Center the HUD on the constraint, but only if this constraint is the home plan.
							if (constraint._debugIdxData.planId === $scope.plan.$id) {
								// MOC-3182
								// MOC-4234 - Only re-center if overlap
								let sumPanelWidth: number =
									PLAN_CONSTANTS.SIDEBAR_WIDTH +
									PLAN_CONSTANTS.CONSTRAINT_PANEL_WIDTH +
									PLAN_CONSTANTS.CONSTRAINT_DETAIL_PANEL_WIDTH;
								let spaceExists: boolean = $scope.hud.w > sumPanelWidth;
								const constraintScreenX: number = $scope.planState.canvasConnector.camera.realToScreenX(
									constraint.data.left
								);
								const constraintScreenY: number = $scope.planState.canvasConnector.camera.realToScreenY(
									constraint.data.top
								);
								const shouldRecenter: boolean =
									constraintScreenX <= sumPanelWidth ||
									constraintScreenX >= $scope.hud.w ||
									constraintScreenY <= 0 ||
									constraintScreenY >= $scope.hud.h;
								if (spaceExists && shouldRecenter) {
									let halfDiff = ($scope.hud.w - sumPanelWidth) / 2;
									let offsetPos = {
										x: $scope.hud.w - halfDiff,
										y: ($scope.hud.h - PLAN_CONSTANTS.TOPBAR_BEIGHT) / 2,
									};
									$scope.hud.focusTicketAt(constraint, offsetPos, 0.5);
								} else if (shouldRecenter) {
									$scope.hud.centerTicket(constraint);
								} // Otherwise do nothing
							}
							// Apply highlight on select
							//if ($scope.plan.$id === constraint._debugIdxData.planId){$scope.tickets.selection.add(constraint._debugIdxData.ticketId);}

							// If this is a constraint linked to procore, we need to fetch the details to show in the detail panel
							if (constraint.data.procoreRfiId) {
								analyticsEventsService.procoreGetRfiPanelEdit($scope.project.$id, $scope.plan.$id);

								var procoreProjectId = $scope.project.procoreProjectId;
								var procoreCompanyId = $scope.project.procoreCompanyId || 'none';
								var rfiId = constraint.data.procoreRfiId;
								// Reach out to touchcore to with the given Procore project ID
								// and RFI ID.  Get back the RFI details form Procore.  The link
								// to Procore for the RFI isn't returned, so it's constructed below
								procoreService
									.getRFI(rfiId, procoreProjectId, procoreCompanyId)
									.pipe(last())
									.subscribe(
										(RFI) => {
											$scope.procore.data = RFI;
											$scope.procore.data.link =
												'https://api.procore.com/' + procoreProjectId + '/project/rfi/show/' + rfiId;
										},
										(errorResponse) => {
											if (errorResponse?.data) {
												Logging.warning(errorResponse.data.message);
											} else if (errorResponse) {
												Logging.warning(errorResponse);
											}
										}
									);
							}
						};

						this.getConstraintColor = function (constraint): void {
							return constraint.data.assignedProjectMemberId && constraint.data.isAccepted
								? constraint.data.assignedProjectMemberRoleId
								: constraint.data.requestedByProjectMemberRoleId;
						};

						// New Edit constraint colors
						this.getAssignedRoleId = function (constraint) {
							if (!constraint) {
								return;
							}
							var assignedPmId =
								constraint.data && constraint.data.assignedProjectMemberId
									? constraint.data.assignedProjectMemberId
									: null;
							var record = $scope.meshedUsers.$getPmRecord(assignedPmId);
							var primaryRole = record ? record.data.roleId : '';
							return constraint.data.assignedProjectMemberRoleId
								? constraint.data.assignedProjectMemberRoleId
								: primaryRole;
						};

						this.getResponsibleRoleId = function (constraint) {
							if (!constraint) {
								return;
							}
							var requestedPmId =
								constraint.data && constraint.data.requestedByProjectMemberId
									? constraint.data.requestedByProjectMemberId
									: null;
							var responsiblePmId =
								constraint.data && constraint.data.responsibleProjectMemberId
									? constraint.data.responsibleProjectMemberId
									: requestedPmId;
							var record = $scope.meshedUsers.$getPmRecord(responsiblePmId);
							var primaryRole = record ? record.data.roleId : 'no-role-style';
							var requestedByRole = constraint.data.requestedByProjectMemberRoleId
								? constraint.data.requestedByProjectMemberRoleId
								: primaryRole;
							return constraint.data.responsibleProjectMemberRoleId
								? constraint.data.responsibleProjectMemberRoleId
								: requestedByRole;
						};

						this.getRequestedByName = function (constraint) {
							if (!constraint) {
								return '';
							}
							return constraint.data.requestedByProjectMemberId
								? $scope.meshedUsers.$getPmRecord(constraint.data.requestedByProjectMemberId).data
										.formattedName
								: $scope.meshedUsers.$getPmRecord(constraint.data.creatorId).data.formattedName;
						};

						// Show only completed constraints
						this.sortByCompletedChanged = function () {
							this.constraints.toggleShowCompleted(this.sortByCompleted);
						};

						this.showConstraintsForCurrentPlanOnlyChanged = function () {
							this.constraints.toggleThisPlanOnly(this.showForCurrentPlanOnly);
						};

						this.toggleOnlyLate = function () {
							this.constraints.toggleOnlyLate(this.showOnlyLate);
						};

						var sortCbs = {
							priority: function (id) {
								return $scope.priorities.$getRecord(id);
							},
							plan: function (id) {
								return $scope.plans.$getRecord(id);
							},
						};

						this.sortByChanged = function () {
							$timeout(() => {
								this.constraints.setSortType(this.sortBy, sortCbs[this.sortBy], null, this.sortDescending);
							});
						};
					},
				],
			};
		},
	])

	.directive('constraintNotePanel', [
		'$timeout',
		function ($timeout) {
			return {
				scope: true,
				template: require('html-loader?root=src/!tpl/constraints/constraint-notes.html'),
				controller: [
					'$scope',
					'$element',
					function ($scope, $element) {
						$scope.dataObj = {
							changed: false,
						};

						$scope.legacyImages = {
							procoreLogoSmall: 'assets/images/procore-logo-small.png',
						};

						$scope.saveNoteChanges = function (id) {
							const newData = {
								priorityId: $scope.ctrl.priorityList ? $scope.ctrl.priorityList.$id : null,
								actualFinish: $scope.dataObj.completeDate || null,
								notes: $scope.ctrl.savedData.notes || null,
							};
							// MOC-4354 - Prevent constraints from turning black if they are completed before accepted
							const isPreAcceptance = this.constraint.data.assignedProjectMemberId && newData.actualFinish;
							const responsibleProjectMemberId = this.constraint.data.assignedProjectMemberId
								? this.constraint.data.assignedProjectMemberId
								: this.constraint.data.responsibleProjectMemberId;
							if (isPreAcceptance) {
								newData['responsibleProjectMemberId'] = responsibleProjectMemberId;
								newData['assignedProjectMemberId'] = null;
								newData['assignedProjectMemberRoleId'] = null;
							}

							if ($scope.planAccessCheck.hasRestrictedAccessSync) {
								id = id || $scope.ctrl.constraintNoteID;
								$scope.ctrl.constraints.miniSaveLockedPlanOnly(id, newData);
							} else {
								newData['complete'] = $scope.ctrl.savedData.complete;
								newData['locationId'] = $scope.ctrl.locationList ? $scope.ctrl.locationList.$id : null;
								$scope.ctrl.constraints
									.miniSave(id || $scope.ctrl.constraintNoteID, newData)
									.then(function () {
										Logging.notice('Your constraint changes have been saved.');
									});
							}
						};

						// window.mything = $scope;

						$scope.changed = function () {
							$timeout(() => {
								// Only mark changed once.
								if (!$scope.dataObj.changed) {
									$scope.dataObj.changed = true;
								}
							});
						};

						$scope.initPriorityDropdownSelection = function (ctrlId) {
							// Get the <select> HTML element for the provided "crtlId", via the top-level element of this panel:
							const asHtmlElement = $element[0] as HTMLElement;
							const selectElement = asHtmlElement.querySelector('#' + ctrlId) as HTMLSelectElement;
							// Initialize it's selection:
							if (selectElement && $scope.ctrl.priorityList) {
								selectElement.value = $scope.ctrl.priorityList;
							}
						};

						$scope.appendNote = function () {
							if (!$scope.dataObj.newNote) {
								return;
							}
							var prependDate = moment(new Date()).format('YYYY-MM-DD');
							$scope.ctrl.savedData.notes = !$scope.ctrl.savedData.notes
								? prependDate.concat(': ', $scope.dataObj.newNote)
								: prependDate.concat(': ', $scope.dataObj.newNote, '\n', $scope.ctrl.savedData.notes);
							$scope.dataObj.newNote = null;
							const newData = { notes: $scope.ctrl.savedData.notes };
							if ($scope.constraint.data.actualFinish) {
								newData['actualFinish'] = $scope.dataObj.completeDate;
							}

							if ($scope.planAccessCheck.hasRestrictedAccessSync) {
								$scope.ctrl.constraints.miniSaveLockedPlanOnly($scope.ctrl.constraintNoteID, newData);
							} else {
								$scope.ctrl.constraints.miniSave($scope.ctrl.constraintNoteID, newData);
							}
						};

						$scope.markComplete = function () {
							// Completion status is read only if this is a Procore linked constraint
							if (
								$scope.constraint.data.procoreRfiId ||
								$scope.planHasRestrictedAccess(this.constraint._debugIdxData['planId'])
							) {
								Logging.warning(CONSTRAINT_LINKED_TO_PROCORE);
								return;
							}

							// Block if plannedFinish is falsy and no actualFinish (Otherwise we could never 'unmark' a constraint as completed
							// lastPlannedFinish check is there because it's possible to trigger the warning if you mass click 'Mark as Completed'
							if (
								!$scope.constraint.data.plannedFinish &&
								!$scope.constraint.data.lastPlannedFinish &&
								!$scope.constraint.data.actualFinish
							) {
								Logging.warning('Cannot mark as complete. No planned finish date set.');
								return;
							}

							// MOC-4353 - Should not be able to complete a constraint on pull side
							if (!$scope.constraint.data.isActive) {
								Logging.warning(CONSTRAINT_CANNOT_COMPLETE_ON_PULL_SIDE);
								return;
							}

							if ($scope.constraint.data.actualFinish) {
								return;
							}
							// Set the complete boolean. This is stored in our savedData object, which is only saved if the 'Save Changes' button is clicked.
							$scope.ctrl.savedData.complete = !$scope.ctrl.savedData.complete;
							// Set the completed date to be the plannedFinish date, if applicable. This makes the 'Set Complete Date' date picker as active.
							//
							$scope.dataObj.completeDate =
								$scope.ctrl.savedData.complete && $scope.constraint.data.plannedFinish
									? $scope.constraint.data.plannedFinish || $scope.constraint.data.lastPlannedFinish
									: null;
							// Mark this constraint as changed, which displays the 'Save Changes' overlay.
							$scope.changed();
						};

						$scope.enterEditMode = function () {
							// If not in edit mode, enter edit mode.
							if (
								!$scope.planHasRestrictedAccess(this.constraint._debugIdxData['planId']) &&
								!$scope.editAreaApi.getState()
							) {
								if (
									$scope.planAccessCheck.hasAccessToTicketSync($scope.constraint) ||
									$scope.planAccessCheck.isAdminSync
								) {
									$scope.editAreaApi.toggle();
								}
							}
						};

						$scope.$watch('ctrl.constraintData.constraint', function (thing) {
							if (!thing) {
								return;
							}
							$scope.constraint = $scope.ctrl.constraintData.constraint;
						});

						$scope.$watch('constraint.data.actualFinish', function (thing) {
							if (!thing && thing !== null && $scope.constraint.data.actualFinish !== '') {
								return;
							}
							$scope.ctrl.savedData.complete = !!$scope.constraint.data.actualFinish;
							$scope.dataObj.completeDate = $scope.constraint.data.actualFinish;
						});
					},
				],
			};
		},
	])

	.directive('constraintCrossPlanDisplay', function () {
		return {
			scope: true,
			template: require('html-loader?root=src/!tpl/constraints/constraint-cross-plan-display.html'),
			controllerAs: 'ctrl',
			bindToController: {
				constraint: '=',
			},
			controller: [
				'$scope',
				'planAccessCheck',
				function ($scope, planAccessCheck) {
					var self = this;

					this.$onInit = function () {
						this.addedToTimeline = !!$scope.timelineTickets.$getCompositeRecord(
							this.constraint._debugIdxData.planId,
							this.constraint.data.id
						);

						// Watch for changes on this constraint
						$scope.timelineTickets.$watch(function (event) {
							if (event.key === self.constraint.$id) {
								// Someone changed this constraint. Let's update our internal state variable.
								self.addedToTimeline = !!$scope.timelineTickets.$getCompositeRecord(
									self.constraint._debugIdxData.planId,
									self.constraint._debugIdxData.ticketId
								);
							}
						});
					};

					this.markComplete = function () {
						// Completion status is read only if this is a Procore linked constraint
						if ($scope.constraint.data.procoreRfiId) {
							// MOC-3141
							Logging.warning(CONSTRAINT_LINKED_TO_PROCORE);
							return;
						}
						if (!planAccessCheck.hasAccessToTicketSync(this.constraint)) {
							return;
						}
						if (
							!this.constraint.data.plannedFinish &&
							!this.constraint.data.lastPlannedFinish &&
							!this.constraint.data.actualFinish
						) {
							Logging.warning('Cannot mark as complete. No planned finish date set.');
							return;
						}
						// MOC-4353 - Should not be able to complete a constraint on pull side
						if (!this.constraint.data.isActive) {
							Logging.warning(CONSTRAINT_CANNOT_COMPLETE_ON_PULL_SIDE);
							return;
						}

						// MOC-4354 - Prevent constraints from turning black if they are completed before accepted
						const responsibleProjectMemberId = this.constraint.data.assignedProjectMemberId
							? this.constraint.data.assignedProjectMemberId
							: this.constraint.data.responsibleProjectMemberId;

						var complete =
							this.constraint.data.plannedFinish && !this.constraint.data.actualFinish ? true : false;
						$scope.constraints2.miniSave(
							this.constraint.$id,
							{
								complete: complete,
								assignedProjectMemberId: null,
								assignedProjectMemberRoleId: null,
								responsibleProjectMemberId: responsibleProjectMemberId,
							},
							true
						);
					};

					// Toggle iof constraint is a timeline constraint or not.
					this.toggleTimelineConstraint = function () {
						if (!planAccessCheck.hasAccessToTicketSync(this.constraint)) {
							Logging.warning('You do not have access to this constraint.');
							return;
						}
						if (!this.addedToTimeline) this.addTimelineConstraint();
						if (this.addedToTimeline) this.removeTimelineConstraint();
					};

					// Add a new timeline constraint
					this.addTimelineConstraint = function () {
						$scope.timelineTickets.addIndex(
							this.constraint._debugIdxData.planId,
							this.constraint._debugIdxData.ticketId
						);

						var conName = clipString(this.constraint.data.activityName || 'No Description');
						var message = '"' + conName + '" added to the timeline in all plans.';
						if (!this.constraint.data.plannedFinish) {
							message += ' (Will appear once a date has been calculated.)';
						}
						fancyNotification.simpleMessage(message, $scope);
					};

					// Remove timeline constraint
					this.removeTimelineConstraint = function () {
						$scope.timelineTickets
							.$remove(
								$scope.timelineTickets.$getCompositeRecord(
									this.constraint._debugIdxData.planId,
									this.constraint.data.id
								)
							)
							.then(function () {
								self.addedToTimeline = false;
							});
					};
				},
			],
		};
	})

	.directive('timelineTickets', [
		'activeColumnService',
		function (activeColumnService) {
			var redomDot = new Redom2('<div data-element-type="timeline-ticket" class="timeline-ticket"></div>');
			var redomGroup = new Redom2(
				'<div data-element-type="timeline-group" class="timeline-ticket timeline-group"><div class="counter">2</div></div>'
			);
			// var redomSquare = new Redom2('<div data-element-type="timeline-ticket" class="timeline-ticket"></div>');

			return {
				link: function (scope: any, element, attrs) {
					var boomed = false;
					// logger.log("-- commenting out to test performance");
					// return;
					//logger.log('element', element);
					var cache;
					var xCache;
					var resultArr;
					var x;
					var z;

					function addDate(tc, left) {
						let betterUser =
							tc.data.responsibleProjectMemberId ||
							tc.data.assignedProjectMemberId ||
							tc.data.requestedByProjectMemberId;
						var thing = {
							origX: left,
							x: left * z + x,
							constraint: tc,
							user: scope.meshedUsers.$getPmRecord(betterUser),
						};
						resultArr.push(thing);
						return thing;
					}

					function cloneDate(newThing, oldThing) {
						return {
							constraint: newThing,
							origX: oldThing.origX,
							x: oldThing.x,
							user: oldThing.user,
						};
					}

					function buildGroup(xPos, tc, cache) {
						var c = cache[xPos];
						if (!c.list) {
							c.list = [];
							tc.local.timelineData = c;
							tc.local.planId = tc._debugIdxData.planId;
							return;
						}
						var newThing = cloneDate(tc, c);
						c.list.push(newThing);
						tc.local.timelineData = newThing;
						tc.local.planId = tc._debugIdxData.planId;
					}

					function update() {
						if (boomed) {
							return;
						}
						//init shit
						x = scope.hud.x;
						z = scope.hud.z;
						resultArr = [];
						cache = {};
						xCache = {};
						scope.timelineTickets.forEach(function (tc) {
							var date = tc.data ? tc.data.plannedFinish || tc.data.lastPlannedFinish : null;
							var xPos = Math.floor(scope.getColumnPositionFromDate(date));
							if (date) {
								if (cache[xPos]) {
									buildGroup(xPos, tc, cache);
									// var c = cache[date];
									// if(!c.list){c.list = [];}
									// var newThing = cloneDate(tc, c);
									// c.list.push(newThing);
									// tc.local.timelineData = newThing;
									// tc.local.planId = tc._debugIdxData.planId;
								} else {
									var calced = null;
									//var x = scope.getColumnPositionFromDate(date);
									if (xPos) {
										//make equivalent x's also group
										calced = addDate(tc, xPos);
										cache[xPos] = calced;
										buildGroup(xPos, tc, cache);
									}
									//tc.local.timelineData = calced;
									//tc.local.planId = tc._debugIdxData.planId;
								}
							}
						});
						AnimationQueue(draw, 'timelineTickets');
					}
					var throttledUpdate = throttle(update);
					activeColumnService.$loaded().then(function () {
						scope.orderedExecution.add('timelineConstraints', update);
						scope.timelineTickets.$loaded().then(function () {
							scope.timelineTickets.$watch(throttledUpdate);
						});
						scope.meshedUsers.$watch(throttledUpdate);
					});

					function buildClassString(res) {
						if (res.constraint.data.type === 'constraint') {
							var list = 'timeline-ticket timeline-dot ';
						} else if (res.constraint.data.type === 'milestone') {
							var list = 'timeline-ticket timeline-diamond ';
						} else {
							var list = 'timeline-ticket ';
						}

						if (res.list.length > 1) {
							var isRelationSelected = false;
							var isSemi = false;
							res.list.forEach(function (innerRes) {
								if (innerRes.constraint.local.relationSelected) {
									isRelationSelected = true;
								}
								if (innerRes.constraint.local.semiSelected) {
									isSemi = true;
								}
							});
							if (isRelationSelected) {
								list += 'relationSelected ';
							}
							if (isSemi) {
								list += 'semi-selected ';
							}

							list += 'timeline-group';
						} else {
							if (res.constraint.local.relationSelected) {
								list += 'relationSelected ';
							}
							if (res.constraint.local.semiSelected) {
								list += 'semi-selected ';
							}
							if (res.user && res.user.data.roleId) {
								list += res.user.data.roleId;
							}
							if (res.constraint.data.roleId) {
								list += ' ' + res.constraint.data.roleId;
							}
						}

						return list;
					}

					function draw() {
						element.empty();
						if (!resultArr.length) {
							return;
						}
						//probably no need to get all of these in all cases,
						// but the performance hit with redom2 is basically neglibable for doing this
						var dotDoms = redomDot.get(resultArr.length);
						var groupDoms = redomGroup.get(resultArr.length);
						// var squareDoms = redomSquare.get(resultArr.length);
						resultArr.forEach(function (res, i) {
							if (!res.constraint || !res.constraint.data) {
								return;
							}
							//multiple in same place
							if (res.list) {
								var dom = groupDoms[i];
								res.list.unshift(res);
								dom.className = buildClassString(res);
								var counter = dom.children[0];
								counter.textContent = res.list.length > 1 ? res.list.length : '';
								dom.timelineList = res.list;
							}
							//normal behavior
							// else{
							// 	logger.log("!!!");
							// 	var dom = dotDoms[i];
							// 	dom.className = buildClassString(res);
							// 	dom.idx = i;
							// 	dom.idxData = res.constraint._debugIdxData;
							// 	dom.timelineData = res;
							// 	res.constraint.local.element = dom;
							// }

							dom.style.left = res.x - 20 + 'px';
							element[0].appendChild(dom);
						});
					}

					scope.$on('$destroy', () => {
						boomed = true;
					});
				},
			};
		},
	])
	.directive('timelineTicketOverflow', function () {
		return {
			scope: false,
			template: require('html-loader?root=src/!tpl/components/timeline-ticket-overflow.html'),
			link: function (scope: any, element, attrs) {
				element.addClass('timeline-ticket-overflow');

				scope.$watch('list', function (val) {
					updateBackground();
				});
				updateBackground();

				scope.$on('$destroy', function () {
					//logger.log('boom');
				});

				function updateBackground() {
					//logger.log('scope.list', scope.list);
					scope.list.forEach(function (ticket) {
						if (ticket.constraint.data.type === 'constraint') {
							let betterUser =
								ticket.constraint.data.responsibleProjectMemberId ||
								ticket.constraint.data.assignedProjectMemberId ||
								ticket.constraint.data.requestedByProjectMemberId;
							var pm = scope.meshedUsers.$getPmRecord(betterUser);
							if (pm) {
								ticket.constraint.local.background = pm.data.roleId;
							}
						} else {
							ticket.constraint.local.background = ticket.constraint.data.roleId;
						}
					});
				}
			},
		};
	})
	.directive('bindInHtml', function () {
		return {
			link: function (scope: any, element, attrs) {
				if (!attrs.bindInHtml) {
					throw new Error('bind-in-html requires a scope property');
				}

				scope.$watch(attrs.bindInHtml, function (val) {
					if (attrs.customKey) {
						var key = attrs.customKey;
					} else {
						var key = attrs.bindInHtml;
					}
					element[0][key] = val;
				});
			},
		};
	})

	.directive('selectSchedule', [
		'$timeout',
		function ($timeout) {
			return {
				template: require('html-loader?root=src/!tpl/panels/role-schedules.html'),
				controllerAs: 'ctrl',
				bindToController: {
					workDays: '=',
					displayWorkDays: '=',
				},
				scope: true,
				controller: [
					'$scope',
					function ($scope) {
						const logger = LoggerServiceFactory.create('selectableSchedule');
						this.toggleAdd = false;
						var self = this;
						this.selectedSchedule = 'project';
						this.updateWorkDays = function () {
							this.displayWorkDays =
								this.selectedSchedule === 'project'
									? 'project'
									: $scope.roles.fb.$getRecord(this.selectedSchedule.$id);
						};

						this.cancel = function () {
							this.role = null;
							this.selectedRole = null;
							this.toggleAdd = false;
						};

						this.changed = function () {
							$timeout(() => {
								if (this.role) {
									delete this.role.isNew;
								}
								this.role = JSON.parse(JSON.stringify(this.selectedRole));
								this.role.isNew = true;
							});
						};

						this.add = function () {
							this.toggleAdd = true;
							if (
								$scope.currentRole &&
								this.unsetRoleWorkDays.length === 1 &&
								!$scope.currentRole.data.workShiftsByDow
							) {
								this.selectedRole = $scope.currentRole;
								this.changed();
							}
						};

						this.delete = function (id) {
							$scope
								.popup({
									title: 'Confirm Delete',
									description: 'Are you sure you want to delete this role schedule?',
								})
								.then(function () {
									// Handle the case where a user deletes a role while another admin is in the promise period/popup
									if (!$scope.roles.fb.$getRecord(id)) {
										Logging.error('Cannot delete! Role no longer exists.');
										return;
									}
									$scope.roles.fb.$getRecord(id).data.workShiftsByDow = null;
									$scope.roles.fb
										.updateRoleWorkDays(id)
										.then(function () {
											Logging.notice('The role schedule has been deleted.');
										})
										.catch(function (error) {
											Logging.error('Failed to delete: ' + error);
										});
								});
						};

						this.save = function () {
							var roleData = $scope.roles.fb.$getRecord(this.role.roleId);
							if (!this.role.workShiftsByDow) {
								Logging.error('Selected role does not have a valid role schedule!');
								return;
							}
							roleData.data.workShiftsByDow = this.role.workShiftsByDow;
							$scope.roles.fb
								.updateRoleWorkDays(this.role.roleId)
								.then(function () {
									Logging.notice('Role schedule has been added.');
									self.cancel();
								})
								.catch(function (error) {
									Logging.error('Failed to add new role schedule: ' + error);
									self.cancel();
									logger.log(error);
								});
						};

						this.generateRoleListNoDow = function () {
							const roleColors: Array<{ $id: string; data: { color: string; id: string } }> =
								$scope.roleColors;
							var list = [];
							$scope.roles.fb.forEach(function (role) {
								if (!role.data.workShiftsByDow) {
									const roleColorId = role.data?.roleColor;
									if (roleColorId) {
										const matchingColor = roleColors.find((elem) => elem.$id === roleColorId);
										if (matchingColor) {
											role.roleColorValue = matchingColor.data.color;
										}
									}
									list.push(role);
								}
							});
							return list;
						};

						var unwatchCurrentRole = $scope.$watch(
							'currentRole',
							function () {
								if ($scope.currentRole.data && $scope.currentRole.data.workShiftsByDow) {
									self.selectedSchedule = $scope.currentRole || 'project';
									self.updateWorkDays(true);
								} else {
									self.selectedSchedule = 'project';
									self.updateWorkDays(true);
								}
							},
							true
						);

						// Cache our list of roles that do not have a role schedule, then watch the role list and update our cache when something changes
						var unwatchRoleList = $scope.$watch(
							'roles.fb',
							function () {
								if (self.role && !$scope.roles.fb.$getRecord(self.role.roleId)) {
									Logging.error('Failed: Role no longer exists');
									self.cancel();
								}
								self.unsetRoleWorkDays = self.generateRoleListNoDow();
							},
							true
						);

						$scope.$on('$destroy', function () {
							unwatchRoleList();
							unwatchCurrentRole();
						});
					},
				],
			};
		},
	])

	.directive('roleDow', function () {
		return {
			scope: true,
			controllerAs: 'ctrl',
			bindToController: {
				role: '=',
			},
			template: require('html-loader?root=src/!tpl/components/role-dow.html'),
			controller: [
				'$scope',
				function ($scope) {
					this.week = [
						{ day: 'Monday', checked: false },
						{ day: 'Tuesday', checked: false },
						{ day: 'Wednesday', checked: false },
						{ day: 'Thursday', checked: false },
						{ day: 'Friday', checked: false },
						{ day: 'Saturday', checked: false },
						{ day: 'Sunday', checked: false },
					];

					// Set initial values
					var self = this;

					this.$onInit = function () {
						if (!this.role.workShiftsByDow) {
							// We want a new instance of our project work schedule and not a reference to our workdays...
							this.role.workShiftsByDow = $scope.projectWorkdays.workShiftsByDow.slice();
						}

						var unwatch = $scope.$watch(
							'roles.fb',
							function () {
								self.week.forEach(function (day, idx) {
									day.checked = self.role.workShiftsByDow[idx];
								});
							},
							true
						);

						$scope.$on('$destroy', function () {
							unwatch();
						});
					};

					function getLastDow() {
						var list = [];
						self.week.forEach(function (dow) {
							list.push(dow.checked);
						});
						return list;
					}

					this.update = function (dow) {
						this.week.forEach(function (day, idx) {
							if (dow === day.day) {
								day.checked = ~~!day.checked;
								// User changed the role since they chose the role initially. The new role may not have the required property, so reinitiate and persist last schedule.
								if (!self.role.workShiftsByDow) {
									self.role.workShiftsByDow = getLastDow();
								}
								self.role.workShiftsByDow[idx] = day.checked;
								if (!self.role.isNew) {
									$scope.roles.fb.updateRoleWorkDays(self.role.roleId);
								}
							}
						});
					};
				},
			],
		};
	})

	//half-assed variant
	.directive('fancyLoggingUi', [
		'$compile',
		'$q',
		'$sanitize',
		function ($compile, $q, $sanitize) {
			return {
				link: function (scope: any, element, attrs) {
					//logger.log('so fancy');
					element.addClass('constraint-message-container');

					function closeWithSillyAnimation(childElement, childScope) {
						childElement.addClass('constraint-message-exit');
						childScope.isClosed = true;
						setTimeout(function () {
							childElement.remove();
						}, 300);
					}

					//actual base
					function showAThing(elementString, scope, makeItCustomOrClassList?) {
						return new $q(function (resolve, reject) {
							var fullyCustom = makeItCustomOrClassList === true;

							var childScope = scope.$new();
							var childElement = $compile(elementString)(childScope);

							//cell api:
							childScope.close = function () {
								closeWithSillyAnimation(childElement, childScope);
								clearTimeout(childScope.timeout);
								//resolve();
							};
							childScope.success = function () {
								closeWithSillyAnimation(childElement, childScope);
								clearTimeout(childScope.timeout);
								resolve(true);
							};

							childElement.addClass('constraint-message');
							element.append(childElement);
							childScope.timeout = setTimeout(function () {
								closeWithSillyAnimation(childElement, childScope);
							}, 12000);

							childScope.$on('$destroy', function () {
								closeWithSillyAnimation(childElement, childScope);
							});
						});
					}

					function simpleMessage(text, scope) {
						var string =
							'<div class="constraint-message-content">\
					<div class="constraint-message-text">\
						' +
							$sanitize(text) +
							'\
					</div>\
					<div class="constraint-message-close" ng-click="close()"><i class="material-icons">close</i></div>\
					</div>';
						return showAThing(string, scope);
					}

					//this might leak?
					function simpleMessageWithButton(text, scope, fn) {
						var childScope = scope.$new();
						childScope.do = { something: fn };
						var string =
							'<div class="constraint-message-content">\
					<div class="constraint-message-text">\
						' +
							$sanitize(text) +
							'<div class="constraint-message-button-wrapper"><button class="legacy-button" ng-click="do.something(); close()">+ Add\
						 Note</button></div>\
					</div>\
					<div class="constraint-message-close" ng-click="close()"><i class="material-icons">close</i></div>\
					</div>';
						return showAThing(string, childScope);
					}

					window.fancyNotification = {
						raw: showAThing,
						simpleMessage: simpleMessage,
						simpleMessageWithButton: simpleMessageWithButton,
					};
				},
			};
		},
	])

	.directive('editArea', function () {
		return {
			scope: {
				obj: '=obj',
			},
			require: 'ngModel',
			transclude: true,
			controllerAs: 'ctrl',
			bindToController: {
				api: '=',
			},
			template: require('html-loader?root=src/!tpl/components/editarea.html'),
			link: function (scope: any, element, attrs, ctrl: any, transclude) {
				// Transcluded element has same scope as this directive
				transclude(scope, function (clone) {
					// Slurp the HTML inside the edit-area tags.
					var transcluded = angular.element('<span></span>').append(clone);
					// Get the child of our main div wrapper
					var child = element.children();
					// Append our slurped html into the pe child of our component template
					element.children().append(transcluded);
				});

				ctrl.$render = function () {
					scope.text = ctrl.$viewValue;
				};

				scope.$watch('text', function (n, old) {
					// When internal variable changes, make sure we push the change to the model.
					// Also update the value of our 'edit mode' variable.
					ctrl.$setViewValue(n);
					scope.ctrl.text = ctrl.$viewValue;
				});
			},
			controller: [
				'$scope',
				function ($scope) {
					const logger = LoggerServiceFactory.create('editArea');
					this.isEdit = false;
					var self = this;

					this.$onInit = function () {
						$scope.$watch('ctrl.api', function () {
							buildApi();
						});
					};
					// On save, push the edit to the model.
					this.save = function () {
						self.isEdit = false;
						$scope.text = self.text;
					};

					// On cancel, reset the edit value back to the model value
					this.cancel = function () {
						self.isEdit = false;
						self.text = $scope.text;
						logger.log(self.isEdit);
					};

					function buildApi() {
						self.api.toggle = function () {
							self.isEdit = !self.isEdit;
						};
						self.api.getState = function () {
							return self.isEdit;
						};
						self.api.setState = function (val) {
							self.isEdit = val;
						};
						self.api.save = self.save;
						self.api.cancel = self.cancel;
						self.api.set = function (val) {
							$scope.text = val;
						};
						self.api.get = function () {
							return $scope.text;
						};
						self.api.getEdit = function () {
							return self.text;
						};
					}
				},
			],
		};
	})

	// Directive api!
	// Two core interactions with this directive:
	// * a function will be added to the scope $whenOpened, that should be called when the menu/ whatever is opened to kick things off
	// * the attribute will be parsed on external interaction and executed
	// Ex:
	// <div some-other-directive close-when-ignored="someCodeToRun(); doesntHaveToBeAFunction = 3;" ng-click="showCode(); $whenOpened()"></div>
	//
	// reasonably likely this won't play nice iwth isolate scopes
	.directive('closeWhenIgnored', [
		'$parse',
		function ($parse) {
			return {
				restrict: 'A',
				link: function (scope: any, element, attrs) {
					scope.$whenOpened = function () {
						$('body').on('mousedown pointerdown touchstart', touchdown);
					};

					function touchdown(event) {
						if (jQuery.contains(element[0], event.target)) {
							return;
						}
						event.stopPropagation();
						//event.preventDefault();
						$parse(attrs.closeWhenIgnored)(scope);
						unEvent();
						scope.$apply();
					}

					function unEvent() {
						$('body').off('mousedown pointerdown touchstart', touchdown);
					}
				},
			};
		},
	])

	//usage:
	// add to element you want to be the container (DO NOT NEST MULITPLES OF THIS)
	// call loadingCtrl.start in the html inside said element when you want the spinner to work
	// - you can also pass in a promise to have it auto resolve on the .finally
	// call loadingCtrl.end to make it go away
	//<div loading-blocker> <button ng-click="loadingCtrl.start(fakeLoading())">Load</button> </div>
	//-- allow a custom child element that determines the position of the spinner (go with direction require method)
	.directive('loadingBlocker', [
		'$timeout',
		function ($timeout) {
			return {
				restrict: 'A',
				scope: true,
				controllerAs: 'loadingCtrl',
				controller: [
					'$element',
					'$attrs',
					function ($element, $attrs) {
						const logger = LoggerServiceFactory.create('loadingBlocker');
						var ctrl = this;

						this.isLoading = false;
						$element.addClass('splash-loader-container');

						var coverUpStandard = $(
							'<div class="splash-loader-layer"><div class="centering-wrapper sl-spinner"><div class="splash-spinner"></div></div></div>'
						);

						var coverUp = $('<div class="splash-loader-layer"></div>');
						var spinner = $(
							'<div class="centering-wrapper sl-spinner"><div class="splash-spinner"></div></div>'
						);
						var checkmark = $(
							'<div class="centering-wrapper sl-icon"><div class="loading-checkmark"></div></div>'
						);
						var xmark = $(
							'<div class="centering-wrapper sl-icon"><div class="loading-x material-icons">close</div></div>'
						);

						var targetElement;

						this.$onInit = function () {
							//logger.log('inity');
							if (this.spinningElement) {
								targetElement = this.spinningElement;
								logger.log('target', targetElement);
							} else {
								targetElement = coverUp;
							}
						};

						this.setTargetElement = function setTargetElement(element) {
							if (this.isLoading) {
								logger.error('too late to change loading target');
								return;
							}
							//logger.log('switched', element);
							targetElement = element;
						};

						this.start = function (p) {
							var self = this;
							this.isLoading = true;
							$element.append(coverUp);
							targetElement.append(spinner);
							targetElement.addClass('is-spinning');

							//if you pass in a promise, it will auto "unload"
							if (p && p.then) {
								p.then(function () {
									self.end();
								}).catch(function (e) {
									self.endWithError(e);
								});
							}
						};
						// experimenting with a delayed transition
						// need to be able to specify exactly when to delay, since the start/ end aren't interesting
						// it's the middle...
						//this.endWithError? is nice and explicit
						//will need to redocument this api
						this.end = function (error) {
							var self = this;
							//yet more fake delay for testing
							return $timeout(400).then(function () {
								targetElement.addClass('no-spin');

								if (error) {
									targetElement.append(xmark);
									targetElement.addClass('error');
									Logging.warning(typeof error === 'object' ? error.message : error);
								} else {
									targetElement.append(checkmark);
								}
								return $timeout(900).then(function () {
									coverUp.remove();
									spinner.remove();
									targetElement.removeClass('no-spin');
									targetElement.removeClass('is-spinning');
									if (error) {
										xmark.remove();
										targetElement.removeClass('error');
									} else {
										checkmark.remove();
									}
									self.isLoading = false;
								});
							});

							// coverUp.addClass('no-spin');
							// coverUp.addClass('checkmark');
							// return $timeout(1000).then(function(){
							// 	coverUp.remove();
							// 	self.isLoading = false;
							// })
						};
						this.endWithError = function endWithError(e) {
							this.end(e);
						};
					},
				],
			};
		},
	])
	.directive('loadingBlockerSpinner', [
		'$timeout',
		function ($timeout) {
			return {
				restrict: 'EA',
				require: '^loadingBlocker',
				link: function (scope: any, element, attrs, loadingBlockerCtrl: any) {
					//logger.log('hi');
					loadingBlockerCtrl.setTargetElement(element);
				},
			};
		},
	])

	.directive('validateDate', function () {
		return {
			restrict: 'A',
			require: '?ngModel',
			priority: 20,
			link: function (scope: any, element, attrs, ngModelCtrl: any) {
				const logger = LoggerServiceFactory.create('validateDate');
				if (!ngModelCtrl) {
					return;
				}
				ngModelCtrl.$validators.formatInvalid = function (modelValue, viewValue) {
					var value = modelValue || viewValue;
					var truthy = true;
					truthy = truthy && /[12]\d\d\d-\d\d-\d\d/.test(value);
					// if(value && !truthy){
					// 	Logging.warning("Dates must be formatted as 'YYYY-MM-DD'.");
					// }
					return truthy;
				};
			},
		};
	})

	.directive('guideLine', function () {
		return {
			restrict: 'EA',
			compile: function (element, attrs) {
				element.addClass('guide-line');
			},
		};
	})

	//don't include "tpl/" in the file name
	.directive('requireInclude', function () {
		//just hardcode this shit until it's gone
		const supportedFiles = {
			'ticket/view.html': require('html-loader?root=src/!src/app/legacy-angularjs/tpl/ticket/view.html'),
		};

		return {
			restrict: 'EA',
			template: function (element, attrs) {
				var file = attrs.requireInclude || attrs.src;
				return supportedFiles[file];
				//return require(fileWithPath);
				// return require("tpl/"+file);
			},
		};
	})

	.directive('legacyLink', function () {
		return {
			restrict: 'A',
			controller: [
				'$scope',
				'$parse',
				'$element',
				'$attrs',
				'legacyRouting',
				function ($scope, $parse, $element, $attrs, legacyRouting) {
					$element.on('click', () => {
						var arr = $parse($attrs.legacyLink)($scope);
						legacyRouting.rawGo(arr);
					});
				},
			],
		};
	});
